import { fullDateAndTime as fullDateAndTimeFormat } from '@/helpers/dateTimeFormats';

const fullDateAndTimeFormatter = new Intl.DateTimeFormat(undefined, fullDateAndTimeFormat);

export default function formatFullDateAndTime(dateTime) {
  if (!dateTime) return '';
  return fullDateAndTimeFormatter.format(dateTime);
}
